import React, { useEffect, useState } from "react";
import baseImg from "../../../../assets/images/full-bleed-normal-header.svg";
import simpleImg from "../../../../assets/images/full-width-image-listings.svg";
import listImg from "../../../../assets/images/list.svg";
import columngridImg from "../../../../assets/images/3-col-grid.svg";
import Image from "../../Image";
import InputFile from "../../../form/InputFile";
import Checkbox from "../../../form/Checkbox";
import Input from "../../../form/Input";
import { motion, AnimatePresence } from "framer-motion";
import Textarea from "../../../form/Textarea";
import useForm from "../../../../hooks/useForm";
import Form from "../../../form/Form";
import Button from "../../../form/Button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { organizationAddEdit } from "../../../../services/organizationService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const headeroptions = [
  { key: "simple", label: "Text overlay", image: simpleImg },
  { key: "base", label: "Full size", image: baseImg },
];

const eventoptions = [
  { key: "list", label: "List", image: listImg },
  { key: "grid", label: "3 column grid", image: columngridImg },
];

const ListingContent = ({
  data = {},
  organizationDetailsRefetch,
  selectedLang,
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [showStoreLink, setShowStoreLink] = useState(false);

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({
      initialState: {
        listBannerLayout: "simple",
        listLayout: "list",
        title: "",
        description: "",
        logo: null,
        searchSortFilter: [],
      },
    });

  useEffect(() => {
    setFieldsValue({
      listBannerLayout: data?.eventSetting?.listBannerLayout || "simple",
      listLayout: data?.eventSetting?.listLayout || "list",
      title: data?.eventSetting?.title?.[selectedLang],
      description: data?.eventSetting?.description?.[selectedLang],
      logo: data?.eventSetting?.logo,
      searchSortFilter: data?.eventSetting?.searchSortFilter,
    });
  }, [data?.eventSetting, selectedLang]);

  useEffect(() => {
    if ((values?.searchSortFilter || [])?.length > 0) {
      setShowStoreLink(true);
    }
  }, [(values?.searchSortFilter || [])?.length]);

  const { mutate: saveEventTheme, isPending } = useMutation({
    mutationFn: async (value) => {
      const res = await organizationAddEdit({
        ...(data?._id && { id: data?._id }),
        requestType: "application/json",
        eventSetting: {
          ...value,
          title: { ...data?.eventSetting?.title, [selectedLang]: value?.title },
          description: {
            ...data?.eventSetting?.description,
            [selectedLang]: value?.description,
          },
        },
      });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        organizationDetailsRefetch();

        toast.success(res?.message);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
  });

  const search_filters = [
    { label: t("Enable search"), value: "search" },
    { label: t("Enable date filter"), value: "date" },
    // { label: "Enable venue filter", value: "venue" },
    { label: t("Enable sort"), value: "sort" },
  ];

  const handleSearchFilterChange = (value) => {
    const current = values?.searchSortFilter || [];
    const updated = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value];
    setFieldsValue({ searchSortFilter: updated });
  };

  return (
    <Form onSubmit={saveEventTheme} handleSubmit={handleSubmit}>
      <div className="relative divide-y divide-slate-200 space-y-5">
        <div className="py-4 md:py-8 px-3 md:px-6 rounded-md space-y-4 border border-gray-200">
          <div className="relative py-3">
            {/* <h2 className="text-xl font-bold text-deep-purple mb-2 font-Montserrat">
              Header banner
            </h2>
            <p className="mb-6 text-sm text-text-secondary font-[300]">
              Add a header to the top of the event listings page
            </p>
            <div className="flex flex-wrap gap-4 mb-3">
              {headeroptions.map((item) => (
                <label
                  key={item?.key}
                  className={`rounded-xl overflow-hidden cursor-pointer border-2 transition-all ${
                    values?.listBannerLayout === item?.key
                      ? "border-primary"
                      : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="theme"
                    value={item?.key}
                    checked={values?.listBannerLayout === item?.key}
                    onChange={() =>
                      handleChange({
                        target: { name: "listBannerLayout", value: item?.key },
                      })
                    }
                    className="hidden"
                  />

                  <div className="w-60 aspect-square overflow-hidden">
                    <Image
                      src={item?.image}
                      alt={item?.label}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="px-4 py-3 border-t text-center bg-gray-50">
                    <h4 className="text-base font-semibold text-primary capitalize">
                      {item?.label}
                    </h4>
                  </div>
                </label>
              ))}
            </div> */}
            <div className="relative mb-3">
              <Input
                label={t("Heading")}
                inputName={"title"}
                value={values?.title}
                onChange={handleChange}
                labelClasses={"!text-base !text-deep-purple !mb-1"}
                inputClasses="!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
              />
            </div>
            <div className="relative">
              <Textarea
                label={t("Description")}
                inputName={"description"}
                inputValue={values?.description}
                onChange={handleChange}
                labelClasses={"!text-base !text-deep-purple !mb-1"}
                inputClasses="!border-surface-05 !bg-surface-04 !h-40 !font-medium !text-deep-purple"
              />
            </div>
          </div>
          {/* <div className="relative py-3">
          <div className="grid grid-cols-2">
            <InputFile
              label="Logo"
              labelClasses={"text-xl font-bold text-deep-purple mb-2"}
              inputPlaceholder="Upload custom logo"
              inputButtonPlaceholder="Browse"
              inputName="document"
              inputValue={undefined}
              inputFilename={selectedFile?.name}
              onChange={handleChange1}
            />
          </div>
        </div> */}
          <div className="relative py-3">
            <h2 className="text-xl font-bold text-deep-purple mb-2 font-Montserrat">
              {t("Event list layout")}
            </h2>
            <p className="mb-3 text-sm text-text-secondary font-[300]">
              {t("Customise the layout of the main list of events")}
            </p>
            <div className="flex flex-wrap gap-4 mb-3">
              {eventoptions.map((item) => (
                <label
                  key={item?.key}
                  className={`rounded-xl overflow-hidden cursor-pointer border-2 transition-all ${
                    values?.listLayout === item?.key
                      ? "border-primary"
                      : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="theme"
                    value={item?.key}
                    checked={values?.listLayout === item?.key}
                    onChange={() =>
                      handleChange({
                        target: { name: "listLayout", value: item?.key },
                      })
                    }
                    className="hidden"
                  />

                  <div className="w-60 aspect-square overflow-hidden">
                    <Image
                      src={item?.image}
                      alt={item?.label}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="px-4 py-3 border-t text-center bg-gray-50">
                    <h4 className="text-base font-semibold deep-purple capitalize">
                      {t(item?.label)}
                    </h4>
                  </div>
                </label>
              ))}
            </div>
          </div>
          <div className="relative py-3">
            <h2 className="text-xl font-bold text-deep-purple mb-1 font-Montserrat">
              {t("Search and filters")}
            </h2>
            <div className="mb-3 text-sm text-text-secondary font-[300]">
              {t("Allow users to search and filter the event listings")}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="relative">
                <div className="space-y-3">
                  <Checkbox
                    checkboxLabel={t("Enable search on event listings")}
                    checkboxLableClass="font-medium text-text-disabled text-lg text-deep-purple"
                    checked={showStoreLink}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setFieldsValue({ searchSortFilter: [] });
                      }
                      setShowStoreLink(e.target.checked);
                    }}
                  />

                  <AnimatePresence initial={false}>
                    {showStoreLink && (
                      <motion.div
                        key="store-input"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.25 }}
                      >
                        <div className="pl-5 border-l border-deep-purple space-y-1">
                          {search_filters.map(({ label, value }) => (
                            <Checkbox
                              key={value}
                              checkboxLabel={label}
                              checkboxLableClass="font-medium text-text-disabled text-base text-deep-purple"
                              checked={(
                                values?.searchSortFilter || []
                              ).includes(value)}
                              value={value}
                              onChange={(e) =>
                                handleSearchFilterChange(e.target.value)
                              }
                            />
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-7 gap-3 justify-end bg-magnolia py-2 md:py-4 sticky bottom-0 right-0 z-[2] pr-6">
        <Button
          buttonType="submit"
          buttonLabel={t("Publish changes")}
          {...(isPending && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </Form>
  );
};

export default ListingContent;
